import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'
import LOCALES from 'src/locales'

export default compose(
  connect(({ locale }) => ({
    locale: locale.locale
  })),
  withProps(({ locale }) => ({
    key: locale,
    messages: LOCALES[locale.slice(0, 2)]
  }))
)(IntlProvider)
